import React from 'react';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {}

export function Image(props: ImageProps){
  return <img {...props} alt={props.alt ?? ''}/>;
};